<template>
  <div class="container-fluid">
    <div class="create-requirements-button" v-if="currentProject">
      <b-button variant="primary" v-b-modal.create-requirement-modal-RequirementsView>New requirement</b-button>
      <b-button variant="secondary" v-b-modal.create-folder-modal-RequirementsView>New folder</b-button>
      <b-button variant="secondary" v-b-modal.import-issues-modal>Import requirements</b-button>
      <b-button variant="secondary" v-b-modal.export-requirements-modal>Export requirements</b-button>
    </div>
    <create-requirement-modal modalId="create-requirement-modal-RequirementsView"></create-requirement-modal>
    <create-folder-modal modalId="create-folder-modal-RequirementsView"></create-folder-modal>
    <import-issues-modal :currentProject="currentProject"></import-issues-modal>
    <export-requirements-modal></export-requirements-modal>
    <move-requirement-modal :requirements="selectedRequirements" modalId="move-requirement-modal-RequirementsView"></move-requirement-modal>
    <delete-requirement-modal :requirements="selectedRequirements" modalId="delete-requirement-modal-RequirementsView"></delete-requirement-modal>
    <div v-if="currentProject">
      <div class="row" v-if="this.items.length > 0">
        <section class="col-md-3 items-list-outer">
          <div :style="selectedRequirements.length > 0 ? '' : 'visibility: hidden;'">
            <span>Selected: </span><b-button variant="warning" size="sm" v-b-modal.move-requirement-modal-RequirementsView>
            Move
          </b-button>
            <b-button variant="danger" size="sm" v-b-modal.delete-requirement-modal-RequirementsView>
              Delete
            </b-button>
          </div>
          <items-list :items="items"></items-list>
        </section>
        <div class="col-md-9">
          <requirements-detail v-if="currentItem && currentItem.type.endsWith('requirement')" :id="Number.parseInt(currentItem.requirement_id)"></requirements-detail>
          <folder-detail v-if="currentItem && currentItem.type === 'folder'" :folderId="Number.parseInt(currentItem.folder_id)"></folder-detail>
        </div>
      </div>
      <div v-else-if="loading">
        <div class="d-flex justify-content-center align-items-center">
          <icon  name="spinner" pulse scale="5"></icon>
        </div>
      </div>
      <div v-else>
        <b-alert show variant="info">Create your first requirement by clicking the "New requirement" button above</b-alert>
      </div>
    </div>
  </div>
</template>

<script>
  import CreateRequirementModal from '@/components/modals/CreateRequirementModal'
  import CreateFolderModal from '@/components/modals/CreateFolderModal'
  import DeleteRequirementModal from '@/components/modals/DeleteRequirementModal'
  import ExportRequirementsModal from '@/components/modals/ExportRequirementsModal'
  import FolderDetail from './FolderDetail.vue'
  import MoveRequirementModal from '@/components/modals/MoveRequirementModal'
  import RequirementsDetail from './RequirementsDetail.vue'
  import ItemsList from './ItemsList.vue'
  import ImportIssuesModal from '@/components/modals/ImportIssuesModal'
  export default {
    components: {
      CreateRequirementModal,
      CreateFolderModal,
      DeleteRequirementModal,
      ExportRequirementsModal,
      FolderDetail,
      MoveRequirementModal,
      RequirementsDetail,
      ImportIssuesModal,
      ItemsList
    },
    data () {
      return {
        items: [],
        loading: false
      }
    },
    computed: {
      currentItem () {
        return this.$store.state.currentItem
      },
      currentProject () {
        return this.$store.state.currentProject
      },
      needToRefreshItemsList () {
        return this.$store.state.needToRefreshItemsList
      },
      openFolderIds () {
        return this.$store.state.openFolderIds
      },
      selectedRequirements () {
        return this.$store.state.selectedRequirements
      }
    },
    watch: {
      currentProject (newValue, oldValue) {
        if (this.currentProject) {
          // Only set current item to null if the project was previously a different project
          // This way, if the project is being set for the first time, don't set current item to null
          // Useful for navigating to the requirement from outside of the app
          if (oldValue && oldValue.id.toString() !== newValue.id.toString()) {
            window.AP.history.pushState(`${newValue.id}-requirements`)
          }
          this.$store.commit('clearOpenFolders')
          this.getPrimaryItems()
          this.$store.commit('clearSelectedRequirements')
        }
      },
      needToRefreshItemsList (currentValue) {
        if (currentValue === true) {
          // Refresh then set the value to be false
          this.getPrimaryItems()
          this.$store.commit('setNeedToRefreshItemsList', false)
        }
      }
    },
    mounted () {
      this.$store.commit('clearOpenFolders')
      if (this.currentProject) {
        this.$store.commit('clearSelectedRequirements')
        this.getPrimaryItems()
      }
    },
    methods: {
      getPrimaryItems () {
        this.loading = true
        let primaryUrl = '/api/item/primary?atlassian_project_id=' + this.currentProject.id
        // Tell the API which folders to expand
        if (Object.keys(this.openFolderIds).length > 0 && this.openFolderIds.constructor === Object) {
          primaryUrl += `&expand=${Object.keys(this.openFolderIds).join('&expand=')}`
        }
        this.$http.get(
          primaryUrl,
        ).then(response => {
          this.items = response.data.items
          this.loading = false
        }, response => {
          console.log('error')
        })
      }
    }
  }
</script>

<style>
  .create-requirements-button {
    padding: 10px 0;
  }
  .items-list-outer {
    overflow-y: auto;
    height: 90vh;
  }
</style>



// WEBPACK FOOTER //
// RequirementsView.vue?544fd06b